var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[_c('h2',[_vm._t("default")],2),_c('div',{staticClass:"underline"})])
}
var staticRenderFns = []

export { render, staticRenderFns }